export enum ConsentRequestStatus
{
    PENDING = "PENDING",
    FAILED = "FAILED",
    ACTIVE = "ACTIVE",
    PAUSED = "PAUSED",
    REVOKED = "REVOKED",
    EXPIRED = "EXPIRED",
    REJECTED = "REJECTED"
}